import type { insuranceMonitorSettingsApiSpec } from "@wingspanhq/wingspan-api-types";

import { selectorPlanTypeDetails } from "../../Benefits/selectors/selectorPlanTypeDetails";
import { WingspanPlanTypes } from "../../Benefits/utils/constants";

export const selectorMasterPolicyNameByPolicyType = (
  policyTypes: insuranceMonitorSettingsApiSpec.PolicyType[] | undefined
) => {
  const wingspanPlanType: WingspanPlanTypes | undefined = policyTypes?.includes(
    "OccupationalAccident"
  )
    ? "WingspanOccupationalAccidentInsurance"
    : policyTypes?.includes("ProfessionalLiability") ||
        policyTypes?.includes("GeneralLiability")
      ? "WingspanProfessionalLiabilityAndGeneralLiabilityInsurance"
      : undefined;

  if (wingspanPlanType) {
    const planDetails = selectorPlanTypeDetails(wingspanPlanType);

    return planDetails.shortName;
  }

  return undefined;
};
